import { utils } from '@credit/promotion-web-sdk';

export function initPromotionSdk() {
  console.info('promotion sdk ready', BIZ_COUNTRY, REACT_APP_ENV);
  try {
    utils.sdkReady({
      region: BIZ_COUNTRY,
      env: REACT_APP_ENV as any,
    });
  } catch (error) {
    console.error('promotion sdk ready error', error);
  }
}
